import { render, staticRenderFns } from "./ConfirmacaoDialog.vue?vue&type=template&id=df670540&scoped=true&lang=pug"
import script from "./ConfirmacaoDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoDialog.vue?vue&type=style&index=0&id=df670540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df670540",
  null
  
)

export default component.exports